import React from 'react';
import AlertSVG from '../../../../svgComponents/AlertSVG';
import { getComputedCSSVariable } from '../../../../../utils/cssVariableHelpers';

interface Props {
  title?: string,
}

const AlertFilterDisplay: React.FC<Props> = ({
  title,
}) => {
  return (
    <span className="d-flex align-items-center mr-2">
      <span className="d-flex align-items-center mr-2">
        <AlertSVG
          color={getComputedCSSVariable('black')}
          style={{
            color: 'var(--black)',
            width: '18px',
            height: '18px',
          }}
        />
      </span>
      <span>{title}</span>
    </span>
  );
};

AlertFilterDisplay.defaultProps = {
  title: 'Reason:',
};

export default AlertFilterDisplay;
